// Full-document render of the Oscar account order-history list: PageSkeleton
// wrapping the legacy tempurpedic orders page -- the "Your Account / Your
// Orders" breadcrumbs, the (possibly CSR owner-named) heading, the CMS aux
// header, one TP OrderDetailTracker block per order (the account variant, from
// the account_rich_orders_json seam), the shared pagination, the two legacy
// empty states, and the customer-service info block (TP's divergent island).
import React from "react";
import { Pagination } from "tsi-common-react/src/apps/customer-account/Pagination/index";
import { t } from "ttag";

import { interfaces, templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { AuxOrderHistoryContent } from "../components/AuxOrderHistoryContent";
import { OrderDetailTracker } from "../components/OrderDetailTracker";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderHistoryDocumentTemplate,
): React.JSX.Element => {
    const trackers = props.account_rich_orders_json.map(
        (payload) => JSON.parse(payload) as interfaces.TPOrderTrackerInterface,
    );
    const hasOrders = trackers.length > 0;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* {% block extra_meta %}: React 19 hoists this into <head>. */}
            <meta name="chatTags" content="orders" />
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
                <section className="breadcrumbs-block">
                    <a href={props.profile_url}>{t`Your Account`}</a> /{" "}
                    {t`Your Orders`}
                </section>

                <h2>{props.orders_heading}</h2>

                <AuxOrderHistoryContent
                    payload={props.aux_order_history_json}
                />

                <div
                    className={`content__copy--full-width content__orders-page${
                        hasOrders
                            ? ""
                            : " content__orders-page--empty-order-status"
                    }`}
                >
                    <div className="orders">
                        <ul className="orders__list">
                            {hasOrders ? (
                                <>
                                    {trackers.map((tracker, i) => (
                                        <li
                                            className="orders__list-item"
                                            key={i}
                                        >
                                            <div className="content__copy--full-width order-summary-wrapper">
                                                <OrderDetailTracker
                                                    data={tracker}
                                                />
                                            </div>
                                        </li>
                                    ))}
                                    {props.pagination && (
                                        <Pagination data={props.pagination} />
                                    )}
                                </>
                            ) : props.form_is_bound ? (
                                <li className="orders__list-item">
                                    {t`No orders match your search.`}
                                </li>
                            ) : (
                                <li className="orders__list-item orders__list-item--empty-order-status">
                                    <h2 className="orders__list-item__title orders__list-item__title--empty-order-status">
                                        {t`You haven't shopped with us.`}
                                    </h2>
                                    <p className="orders__list-item__copy orders__list-item__copy--empty-order-status">
                                        {t`Please check back after your first purchase to view your order details.`}
                                    </p>
                                    <a
                                        className="button"
                                        href={props.root_page_url}
                                    >
                                        {t`Shop now`}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
